(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.lnm-explainer__media,.lnm-explainer__body,.lnm-balance-col,.lnm-approach-card,.lnm-research-card').forEach(function (el) {
    observer.observe(el);
  });
})();
